<template>
  <div class="dashboard">
    <div class="row">
      <div class="col-12">
        <h4>Real Time Mornitor</h4>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 table-responsive">
        <div>
          <b-tabs>
            <b-tab title="ฝั่งคุณลูกค้า" active>
              <div class="my-4">
                <router-link class="btn btn-primary mr-2" to="/hourly-report?customer_type=customer">Hourly Report</router-link>
                <router-link class="btn btn-primary mr-2" to="/daily-report?customer_type=customer">Daily Report</router-link>
                <router-link class="btn btn-primary mr-2" to="/monthly-report?customer_type=customer">Monthly Report</router-link>
              </div>
              <table class="table agent-table">
                <thead>
                  <tr>
                    <th>
                      Active Agent
                      <a class="ml-2" href="" :class="getSortClass('customer', 'id')" @click.prevent="sort('customer', 'id')"><span v-html="getSortIcon('customer', 'id')"></span></a>
                    </th>
                    <th class="text-center">
                      Status
                      <a class="ml-2" href="" :class="getSortClass('customer', 'active')" @click.prevent="sort('customer', 'active')"><span v-html="getSortIcon('customer', 'active')"></span></a>
                    </th>
                    <th class="text-center">
                      Last Activity
                      <a class="ml-2" href="" :class="getSortClass('customer', 'last_active_at')" @click.prevent="sort('customer', 'last_active_at')"><span v-html="getSortIcon('customer', 'last_active_at')"></span></a>
                    </th>
                    <th class="text-center">
                      Today New Contact
                      <a class="ml-2" href="" :class="getSortClass('customer', 'today_new_contact')" @click.prevent="sort('customer', 'today_new_contact')"><span v-html="getSortIcon('customer', 'today_new_contact')"></span></a>
                    </th>
                    <th class="text-center">
                      In Process
                      <a class="ml-2" href="" :class="getSortClass('customer', 'in_process')" @click.prevent="sort('customer', 'in_process')"><span v-html="getSortIcon('customer', 'in_process')"></span></a>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="admin in customerAdmins" :key="admin.id">
                    <td>
                      <img :src="admin.profile_picture" class="rounded-circle img-circle-sm mr-2" width="32" alt=""> {{ admin.name }}
                    </td>
                    <td class="text-center">
                      <div>
                        <span v-html="$options.filters.activeStatus(admin.active)"></span>
                      </div>
                      <div v-if="admin.active === 2 && admin.logs && admin.logs.length">
                        <span class="text-muted">({{ admin.logs[admin.logs.length - 1].remark ? admin.logs[admin.logs.length - 1].remark : 'ไม่ระบุ' }})</span>
                      </div>
                    </td>
                    <td class="text-center">
                      {{ admin.last_active_at | prettyDate }}
                    </td>
                    <td class="text-center">
                      {{ admin.today_new_contact }}
                    </td>
                    <td class="text-center">
                      {{ admin.in_process}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
            <b-tab title="ฝั่งคุณแม่บ้าน">
              <div class="my-4">
                <router-link class="btn btn-primary mr-2" to="/hourly-report?customer_type=beneat_professional">Hourly Report</router-link>
                <router-link class="btn btn-primary mr-2" to="/daily-report?customer_type=beneat_professional">Daily Report</router-link>
                <router-link class="btn btn-primary mr-2" to="/monthly-report?customer_type=beneat_professional">Monthly Report</router-link>
              </div>
              <table class="table agent-table">
                <thead>
                  <tr>
                    <th>
                      Active Agent
                      <a class="ml-2" href="" :class="getSortClass('beneat_professional', 'id')" @click.prevent="sort('beneat_professional', 'id')"><span v-html="getSortIcon('beneat_professional', 'id')"></span></a>
                    </th>
                    <th class="text-center">
                      Status
                      <a class="ml-2" href="" :class="getSortClass('beneat_professional', 'active')" @click.prevent="sort('beneat_professional', 'active')"><span v-html="getSortIcon('beneat_professional', 'active')"></span></a>
                    </th>
                    <th class="text-center">
                      Last Activity
                      <a class="ml-2" href="" :class="getSortClass('beneat_professional', 'last_active_at')" @click.prevent="sort('beneat_professional', 'last_active_at')"><span v-html="getSortIcon('beneat_professional', 'last_active_at')"></span></a>
                    </th>
                    <th class="text-center">
                      Today New Contact
                      <a class="ml-2" href="" :class="getSortClass('beneat_professional', 'today_new_contact')" @click.prevent="sort('beneat_professional', 'today_new_contact')"><span v-html="getSortIcon('beneat_professional', 'today_new_contact')"></span></a>
                    </th>
                    <th class="text-center">
                      In Process
                      <a class="ml-2" href="" :class="getSortClass('beneat_professional', 'in_process')" @click.prevent="sort('beneat_professional', 'in_process')"><span v-html="getSortIcon('beneat_professional', 'in_process')"></span></a>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="admin in beneatProfessionalAdmins" :key="admin.id">
                    <td>
                      <img :src="admin.profile_picture" class="rounded-circle img-circle-sm mr-2" width="32" alt=""> {{ admin.name }}
                    </td>
                    <td class="text-center">
                      <div>
                        <span v-html="$options.filters.activeStatus(admin.active)"></span>
                      </div>
                      <div v-if="admin.active === 2 && admin.logs && admin.logs.length">
                        <span class="text-muted">({{ admin.logs[admin.logs.length - 1].remark ? admin.logs[admin.logs.length - 1].remark : 'ไม่ระบุ' }})</span>
                      </div>
                    </td>
                    <td class="text-center">
                      {{ admin.last_active_at | prettyDate }}
                    </td>
                    <td class="text-center">
                      {{ admin.today_new_contact }}
                    </td>
                    <td class="text-center">
                      {{ admin.in_process}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
            <b-tab title="ฝั่งผู้สมัคร">
              <div class="my-4">
                <router-link class="btn btn-primary mr-2" to="/hourly-report?customer_type=professional">Hourly Report</router-link>
                <router-link class="btn btn-primary mr-2" to="/daily-report?customer_type=professional">Daily Report</router-link>
                <router-link class="btn btn-primary mr-2" to="/monthly-report?customer_type=professional">Monthly Report</router-link>
              </div>
              <table class="table agent-table">
                <thead>
                  <tr>
                    <th>
                      Active Agent
                      <a class="ml-2" href="" :class="getSortClass('professional', 'id')" @click.prevent="sort('professional', 'id')"><span v-html="getSortIcon('professional', 'id')"></span></a>
                    </th>
                    <th class="text-center">
                      Status
                      <a class="ml-2" href="" :class="getSortClass('professional', 'active')" @click.prevent="sort('professional', 'active')"><span v-html="getSortIcon('professional', 'active')"></span></a>
                    </th>
                    <th class="text-center">
                      Last Activity
                      <a class="ml-2" href="" :class="getSortClass('professional', 'last_active_at')" @click.prevent="sort('professional', 'last_active_at')"><span v-html="getSortIcon('professional', 'last_active_at')"></span></a>
                    </th>
                    <th class="text-center">
                      Today New Contact
                      <a class="ml-2" href="" :class="getSortClass('professional', 'today_new_contact')" @click.prevent="sort('professional', 'today_new_contact')"><span v-html="getSortIcon('professional', 'today_new_contact')"></span></a>
                    </th>
                    <th class="text-center">
                      In Process
                      <a class="ml-2" href="" :class="getSortClass('professional', 'in_process')" @click.prevent="sort('professional', 'in_process')"><span v-html="getSortIcon('professional', 'in_process')"></span></a>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="admin in professionalAdmins" :key="admin.id">
                    <td>
                      <img :src="admin.profile_picture" class="rounded-circle img-circle-sm mr-2" width="32" alt=""> {{ admin.name }}
                    </td>
                    <td class="text-center">
                      <div>
                        <span v-html="$options.filters.activeStatus(admin.active)"></span>
                      </div>
                      <div v-if="admin.active === 2 && admin.logs && admin.logs.length">
                        <span class="text-muted">({{ admin.logs[admin.logs.length - 1].remark ? admin.logs[admin.logs.length - 1].remark : 'ไม่ระบุ' }})</span>
                      </div>
                    </td>
                    <td class="text-center">
                      {{ admin.last_active_at | prettyDate }}
                    </td>
                    <td class="text-center">
                      {{ admin.today_new_contact }}
                    </td>
                    <td class="text-center">
                      {{ admin.in_process}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      customerAdmins: [],
      beneatProfessionalAdmins: [],
      professionalAdmins: [],
      customerUnsortedAdmins: [],
      beneatProfessionalUnsortedAdmins: [],
      professionalUnsortedAdmins: [],
      sortBy: {
        customer: '',
        professional: '',
        beneat_professional: ''
      },
      sortOrder: {
        customer: '',
        professional: '',
        beneat_professional: ''
      }
    }
  },
  computed: {
    ...mapState('admin', ['admin'])
  },
  methods: {
    getSortClass (customerType, sortBy) {
      if (this.sortBy[customerType] === sortBy) {
        return { 'badge': true, 'badge-success': true }
      }
      return { 'badge': true, 'badge-light': true }
    },
    getSortIcon (customerType, sortBy) {
      if (this.sortBy[customerType] === sortBy) {
        if (this.sortOrder[customerType] === 'desc') {
          return '<i class="fas fa-sort-up"></i>'
        } else {
          return '<i class="fas fa-sort-down"></i>'
        }
      }
      return '-'
    },
    sort (customerType, sortBy) {
      if (this.sortBy[customerType] !== sortBy) {
        this.sortBy[customerType] = sortBy
        this.sortOrder[customerType] = 'asc'
      } else {
        if (this.sortOrder[customerType] === 'asc') {
          this.sortOrder[customerType] = 'desc'
        } else {
          this.sortOrder[customerType] = 'asc'
        }
      }
      if (customerType === 'customer') {
        this.customerAdmins = [ ...this.customerUnsortedAdmins ]
        if (this.sortOrder[customerType] === 'asc') {
          this.customerAdmins.sort((a, b) => (a[sortBy] > b[sortBy]) ? 1 : -1)
        } else {
          this.customerAdmins.sort((a, b) => (a[sortBy] < b[sortBy]) ? 1 : -1)
        }
      } else if (customerType === 'beneat_professional') {
        this.beneatProfessionalAdmins = [ ...this.beneatProfessionalUnsortedAdmins ]
        if (this.sortOrder[customerType] === 'asc') {
          this.beneatProfessionalAdmins.sort((a, b) => (a[sortBy] > b[sortBy]) ? 1 : -1)
        } else {
          this.beneatProfessionalAdmins.sort((a, b) => (a[sortBy] < b[sortBy]) ? 1 : -1)
        }
      } else if (customerType === 'professional') {
        this.professionalAdmins = [ ...this.professionalUnsortedAdmins ]
        if (this.sortOrder[customerType] === 'asc') {
          this.professionalAdmins.sort((a, b) => (a[sortBy] > b[sortBy]) ? 1 : -1)
        } else {
          this.professionalAdmins.sort((a, b) => (a[sortBy] < b[sortBy]) ? 1 : -1)
        }
      }
    },
    async getActiveAdmins () {
      const res = await axios.get('admins/active')
      if (res.status === 200) {
        this.customerAdmins = res.data.customerAdmins ? res.data.customerAdmins : []
        this.beneatProfessionalAdmins = res.data.beneatProfessionalAdmins ? res.data.beneatProfessionalAdmins : []
        this.professionalAdmins = res.data.professionalAdmins ? res.data.professionalAdmins : []
        this.customerUnsortedAdmins = res.data.customerAdmins ? res.data.customerAdmins : []
        this.beneatProfessionalUnsortedAdmins = res.data.beneatProfessionalAdmins ? res.data.beneatProfessionalAdmins : []
        this.professionalUnsortedAdmins = res.data.professionalAdmins ? res.data.professionalAdmins : []
      } else {
        this.customerAdmins = []
        this.beneatProfessionalAdmins = []
        this.professionalAdmins = []
        this.customerUnsortedAdmins = []
        this.beneatProfessionalUnsortedAdmins = []
        this.professionalUnsortedAdmins = []
      }
    }
  },
  sockets: {
    newActivity (data) {
      this.customerUnsortedAdmins = data.customerAdmins
      this.beneatProfessionalUnsortedAdmins = data.beneatProfessionalAdmins
      this.professionalUnsortedAdmins = data.professionalAdmins

      let sortBy = ''
      this.customerAdmins = [ ...this.customerUnsortedAdmins ]
      if (this.sortBy['customer']) {
        sortBy = this.sortBy['customer']
        if (this.sortOrder['customer'] === 'asc') {
          this.customerAdmins.sort((a, b) => (a[sortBy] > b[sortBy]) ? 1 : -1)
        } else {
          this.customerAdmins.sort((a, b) => (a[sortBy] < b[sortBy]) ? 1 : -1)
        }
      }
      this.beneatProfessionalAdmins = [ ...this.beneatProfessionalUnsortedAdmins ]
      if (this.sortBy['beneat_professional']) {
        sortBy = this.sortBy['beneat_professional']
        if (this.sortOrder['beneat_professional'] === 'asc') {
          this.beneatProfessionalAdmins.sort((a, b) => (a[sortBy] > b[sortBy]) ? 1 : -1)
        } else {
          this.beneatProfessionalAdmins.sort((a, b) => (a[sortBy] < b[sortBy]) ? 1 : -1)
        }
      }
      this.professionalAdmins = [ ...this.professionalUnsortedAdmins ]
      if (this.sortBy['professional']) {
        sortBy = this.sortBy['professional']
        if (this.sortOrder['professional'] === 'asc') {
          this.professionalAdmins.sort((a, b) => (a[sortBy] > b[sortBy]) ? 1 : -1)
        } else {
          this.professionalAdmins.sort((a, b) => (a[sortBy] < b[sortBy]) ? 1 : -1)
        }
      }
    }
  },
  mounted () {
    this.getActiveAdmins()
  }
}
</script>

<style lang="scss" scoped>
div.dashboard {
  padding: 1rem;
}
.agent-table {
  font-size: 0.8rem;
}
.agent-table th {
  border-top: hidden;
}
</style>
